<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:    质检总览 
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="qc-overview header-padding">
    <f-page-header />
    <el-card v-loading="loading" class="mb-md" shadow="never">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="stat">
            <div class="title mb">今日质检</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <i class="iconfont icon-day stat-icon text-warning" />
              </el-col>
              <el-col :span="8">
                <div class="flex column align-items-center">
                  <div class="">良品率</div>
                  <div class="mt">
                    <span class="number font-36 text-bold mr-xs">{{ stat.toady_non_defective_rate }}</span>%
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex column">
                  <div class="flex">
                    <div class="">质检数</div>
                    <div class="number font-16 ml-sm text-bold">{{ stat.today_qc_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">良品数</div>
                    <div class="number font-16 ml-sm text-success text-bold">{{ stat.today_non_defective_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">次品数</div>
                    <div class="number font-16 ml-sm text-danger text-bold">{{ stat.today_defective_num }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat">
            <div class="title mb">本周质检</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <i class="iconfont icon-week stat-icon text-warning" />
              </el-col>
              <el-col :span="8">
                <div class="flex column align-items-center">
                  <div class="">良品率</div>
                  <div class="mt">
                    <span class="number font-36 text-bold mr-xs">{{ stat.week_non_defective_rate }}</span>%
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex column">
                  <div class="flex">
                    <div class="">质检数</div>
                    <div class="number font-16 ml-sm text-bold">{{ stat.week_qc_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">良品数</div>
                    <div class="number font-16 ml-sm text-success text-bold">{{ stat.week_non_defective_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">次品数</div>
                    <div class="number font-16 ml-sm text-danger text-bold">{{ stat.week_defective_num }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat">
            <div class="title mb">本月质检</div>
            <el-row :gutter="20">
              <el-col :span="8">
                <i class="iconfont icon-month stat-icon text-warning" />
              </el-col>
              <el-col :span="8">
                <div class="flex column align-items-center">
                  <div class="">良品率</div>
                  <div class="mt">
                    <span class="number font-36 text-bold mr-xs">{{ stat.month_non_defective_rate }}</span>%
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex column">
                  <div class="flex">
                    <div class="">质检数</div>
                    <div class="number font-16 ml-sm text-bold">{{ stat.month_qc_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">良品数</div>
                    <div class="number font-16 ml-sm text-success text-bold">{{ stat.month_non_defective_num }}</div>
                  </div>
                  <div class="flex mt-sm">
                    <div class="">次品数</div>
                    <div class="number font-16 ml-sm text-danger text-bold">{{ stat.month_defective_num }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-row :gutter="20">
      <el-col :span="16">
        <el-card shadow="never">
          <div class="filter-container">
            <div class="flex" style="height: 40px;">
              <f-radio-btn-group v-model="query.is_abnormal" :groups="radios" type="minor" @change="fetchList(1)" class="mr btn-filter" />
              <span class="filter-item sm">
                <f-date-range-picker v-model="date" @change="fetchList(1)" :disablerange="disablerange" />
              </span>
            </div>
          </div>

          <el-table v-loading="listloading" ref="listTable" :data="list" size="medium" class="padding-small" height="561" style="width: 100%" >
            <el-table-column type="index" label="#" width="60" />

            <el-table-column label="质检时间" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.inspect_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>

            <el-table-column label="工单" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link :underline="false" class="link-class" @click="toDetail(scope.row.workorderid)">
                  <div class="flex align-items-center">
                    <div class="text-muted order-no">{{ scope.row.workorder_no}}</div>
                    <icon-svg v-if="scope.row.type == 1" icon-class="maintask" style="font-size: 22px"/>
                    <icon-svg v-if="scope.row.type == 2" icon-class="subtask" style="font-size: 22px"/>
                  </div>
                  <div class="ellipsis">{{ scope.row.workorder_title}}</div>
                </el-link>
              </template>
            </el-table-column>

            <el-table-column label="良品数" min-width="80" show-overflow-tooltip align="right">
              <template slot-scope="scope">
                <span class="number font-16 text-bold">{{ scope.row.non_defective_num }}</span>
              </template>
            </el-table-column>

            <el-table-column label="次品数" min-width="80" show-overflow-tooltip align="right">
              <template slot-scope="scope">
                <span class="number font-16 text-bold" :class="{ 'text-danger': scope.row.defective_num }">{{ scope.row.defective_num }}</span>
              </template>
            </el-table-column>

            <el-table-column label="良品率" min-width="80" show-overflow-tooltip align="right">
              <template slot-scope="scope">
                <span class="number font-16 text-bold" :class="{ 'text-danger': scope.row.defective_num }">{{ scope.row.passrate }}%</span>
              </template>
            </el-table-column>
            
            <el-table-column width="20" />

            <el-table-column label="操作员" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="scope.row.operator" class="flex align-items-center">
                  <f-user-avatar :user="scope.row.operator"></f-user-avatar>
                  <span class="ml-xs">{{scope.row.operator.username}}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="质检员" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="scope.row.inspector" class="flex align-items-center">
                  <f-user-avatar :user="scope.row.inspector"></f-user-avatar>
                  <span class="ml-xs">{{scope.row.inspector.username}}</span>
                </div>
              </template>
            </el-table-column>

            <template slot="empty">
              <img class="image huger mt-lg" src="@/assets/empty.png">
              <div class="font-md mb-hg">暂无数据</div>
            </template>
          </el-table>
          <div class="flex justify-content-space-between mt">
            <el-button class="" plain :disabled="total === 0" size="mini" @click="exportList">导出</el-button>

            <f-pagination :sizesShow="false" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchList" />
          </div>

        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card v-loading="rankloading" shadow="never">
          <div class="font-16 mb-lg">优秀质检员</div>
          <el-scrollbar :native="false" view-class="el-scrollbar-view">
            <div style="height: 617px;">
              <div v-if="!inspectors.length" class="flex-center column pt-hg">
                <img class="image huger mt-lg" src="@/assets/empty.png">
                <div class="font-md mb-hg">暂无数据</div>
              </div>
              <div v-else class="flex column">
                <div v-for="(item, index) in inspectors" :key="index" class="inspector mb-md">
                  <div class="flex justify-content-space-between align-items-center mb-lg">
                    <div class="flex align-items-center">
                      <f-user-avatar :user="item"></f-user-avatar>
                      <span class="ml font-16">{{ item.username }}</span>
                    </div>
                    <div class="text-muted">已绑定 {{item.station_num}} 个工位</div>
                  </div>
                  <el-row>
                    <el-col :span="8">
                      <div class="flex-center column">
                        <div class="number font-24 text-bold">{{item.day_qc_num}}</div>
                        <div class="text-muted mt-sm">今日质检数</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="flex-center column">
                        <div class="number font-24 text-bold">{{item.week_qc_num}}</div>
                        <div class="text-muted mt-sm">本周质检数</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="flex-center column">
                        <div class="number font-24 text-bold">{{item.month_qc_num}}</div>
                        <div class="text-muted mt-sm">本月质检数</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { qcStatApi, qcListApi, qcExportApi, qcRankApi } from '@/api/qc/indexApi'

const nowDate = parseInt((new Date().getTime() / 1000).toString())
const yesterday = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24
const last7 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 7
const last30 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 30
const last90 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600* 24 * 90

export default {
  name: 'QcOverview',

  components: {},

  data() {
    return {
      disablerange: [last90, nowDate],
      total: 0,
      query: {
        is_abnormal: 0,
        starttime: null,
        endtime: null,
        pize: 10,
        pindex: 1
      },
      date: null,
      stat: {},
      list: [],
      rankloading: false,
      loading: false,
      listloading: false,
      radios: [
        { value: 0, title: '全部质检' },
        { value: 1, title: '异常质检' }
      ],
      loading: false,
      inspectors: []
    }
  },

  created() {
    this.fetchData()
    this.fetchList()
    this.fetchRank()
  },

  methods: {
    fetchData() {
      this.loading = true
      qcStatApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.stat = Object.assign({}, res.data)
        }
      })
    },

    fetchRank() {
      this.rankloading = true
      qcRankApi().then(res => {
        this.rankloading = false
        if (!res.errno) {
          this.inspectors = res.data
        }
      })
    },

    fetchList(page) {
      this.listloading = true
      if (page) this.query.pindex = page
      if (this.date) {
        this.query.starttime = this.date[0]
        this.query.endtime = this.date[1]
      } else {
        this.query.starttime = null
        this.query.endtime = null
      }
      qcListApi(this.query).then(res => {
        this.listloading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },

    toDetail(id) {
      this.$detail(id)
    },

    exportList() {
      if (this.date) {
        this.query.starttime = this.date[0]
        this.query.endtime = this.date[1]
      } else {
        this.query.starttime = null
        this.query.endtime = null
      }
      qcExportApi(this.query).then(res => {
        if (!res.errno) {
          window.open(res.data.url)
          this.$message.success('质检记录导出成功！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qc-overview {
  position: relative;
  .stat {
    width: 100%;
    height: 160px;
    border-radius: 4px;
    background: #f8f9fc;
    padding: 20px;
    .stat-icon {
      font-size: 80px;
    }
  }
  .inspector {
    width: 100%;
    height: 170px;
    border-radius: 4px;
    background: #f8f9fc;
    border-left: 3px solid #e6a23c;
    padding: 20px;
  }
  /deep/ .btn-filter {
    .f-radios {
      .opts {
        background-color: #f5f5f5;
      }
      .active {
        background-color: #fff;
      }
    }
  }
  >.el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 30px 0;
      }
    }
  }
  .iconfont {
    color: rgba($color: #e6a23c, $alpha: 0.45);
  }

  .link-class {
    width: 100%;
    /deep/.el-link--inner {
      width: 100%;
    }
  }
}
</style>
